var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnSeePath(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 25,
    viewBox: "0 0 69 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 68,
    height: 24,
    rx: 7.5,
    fill: "white",
    stroke: "#1D4993"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.404 16.532V15.716H14V12.956H17.276V12.164H10.856V8.792H17.168V7.988H9.872V12.956H13.004V15.716H8.624V16.532H18.404ZM28.4311 16.508V15.704H24.0391V13.388H27.2551V7.892H26.2951V9.812H20.7991V7.892H19.8271V13.388H23.0431V15.704H18.6751V16.508H28.4311ZM26.2951 12.596H20.7991V10.616H26.2951V12.596ZM38.2457 12.62H39.2297V7.124H38.2457V12.62ZM36.0137 7.652H31.1177V8.456H34.9457C34.7897 10.196 33.3137 11.456 30.5777 12.044L30.9377 12.836C34.1057 12.128 36.0137 10.376 36.0137 7.652ZM39.5897 17.78V17H33.2657V15.752H39.2297V13.136H32.2577V13.916H38.2457V15.02H32.2817V17.78H39.5897ZM46.2688 13.04L46.7368 12.284C45.1528 11.828 44.1088 10.64 44.1088 9.356V9.176H46.4848V8.384H44.1088V7.076H43.1248V8.384H40.7368V9.176H43.1248V9.356C43.1248 10.76 42.0208 11.996 40.4368 12.476L40.9168 13.256C42.1768 12.836 43.1608 11.996 43.6288 10.88C44.1088 11.888 45.0208 12.668 46.2688 13.04ZM50.3848 10.604V9.788H48.7888V7.136H47.8048V13.376H48.7888V10.604H50.3848ZM45.9568 14.744H48.9688V13.964H41.9248V14.744H44.9248C44.7688 15.872 43.2568 16.832 41.5168 17.084L41.8648 17.84C43.4608 17.588 44.8288 16.82 45.4408 15.74C46.0528 16.808 47.4448 17.6 49.0168 17.852L49.3888 17.096C47.6488 16.808 46.1488 15.86 45.9568 14.744ZM59.3078 17.888V7.124H58.3238V17.888H59.3078ZM56.1518 8.288H51.1118V9.08H55.1558C54.9518 11.636 53.5118 13.7 50.6198 15.08L51.1478 15.884C54.7358 14.12 56.1518 11.396 56.1518 8.288Z",
    fill: "#1D4993"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnSeePath);
export default __webpack_public_path__ + "static/media/btnSeePath.bbe2a36bce553e039a95362f9572487d.svg";
export { ForwardRef as ReactComponent };